module.exports = __webpack_public_path__ + "images/9874d476bb7fc17993ba975bc83f2d77.svg";